/** @jsx jsx */
import { jsx, Container } from 'theme-ui';

import Layout from 'components/layout';
import SEO from 'components/seo';

const PrivacyPage = () => (
  <Layout>
    <SEO title="Privacy Policy" />
    <section sx={styles.section}>
      <Container sx={styles.containerBox}>
        <h2> PRIVACY POLICY </h2>
        <small>
          <i> Last Updated: 21 Sep. 2018 </i>
        </small>
        <p>
          This privacy policy applies to Principal Software (W.L.L) Website, Principal Workplace service, Healthy Family Center application,
          or any other provided application on any platform or device. Here after Principal Software (W.L.L.) and
          its provided services or applications is referred to as (we), while all parties making use of these services
          and applications are referred to as (you). This privacy policy applies to information we collect when
          you use or our services, application, or just interact with us. We may change this privacy policy from
          time to time. Whenever we make changes to this privacy policy, the changes are effective two day after
          we post the revised privacy policy (as indicated by revising the date at the top of our privacy policy).
          We encourage you to review our privacy policy whenever you access our services to stay informed about
          our information practices and the ways you can help protect your privacy.
        </p>

        <p>
          We collect information you provide directly to us. For example, we collect information when you participate in any interactive
          features of our services, fill out a form, request customer support, provide any contact or identifying
          information or otherwise communicate with us. The types of information we may collect include your name,
          email address, postal address, credit card information and other contact or identifying information you
          choose to provide.
        </p>
        <p>
          When you first launch any of our web based services or mobile applications that collect location information, you will be
          asked to consent to the application's collection of this information. If you initially consent to our
          collection of location information, you can subsequently stop the collection of this information at any
          time by changing the preferences on your web browser or mobile device. **[If you do so, certain features
          thereof, may no longer function.]** You may also stop our collection of location information by following
          the standard end subscription or uninstall process. In case of web based services we ensure ending your
          subscription removes all of your provided, collected or concluded data and information. In case of uninstalling
          any of our mobile applications, it is your responsibility to ensure the removal of all application related
          data using your mobile device settings.
        </p>
        <p>
          Most web browsers are set to accept cookies by default. If you prefer, you can usually choose to set your browser to remove
          or reject browser cookies. Please note that if you choose to remove or reject cookies, this could affect
          the availability and functionality of our services.
        </p>

        <p>

          We use information about you for various purposes, including to:
        </p><ul>
          <li> Provide, maintain and improve our services.</li>
          <li> Provide services you request, process transactions and to send you related information.</li>
          <li> Send you technical notices, updates, security alerts and support and administrative messages.</li>
          <li> Respond to your comments, questions and requests and provide customer service.</li>
          <li> Communicate with you about news and information related to our service.</li>
          <li> Monitor and analyze trends, usage and activities in connection with our services.</li>
          <li> Personalize and improve our services.</li>
        </ul>
        <p></p>

        <p>
          If for the purpose of providing you with access to the service, or to provide you with better service in general, we may
          need to combine information obtained from other sources, we shall always obtain your consent to do so
          for the specific named source. Other sources for data include for example , a third-party service whose
          application you have authorized or used to sign in.
        </p>

        <p>
          We may share personal information about you as follows:

        </p><ul>
          <li> If we believe disclosure is reasonably necessary to comply with any applicable law, regulation, legal
            process or governmental request.</li>
          <li> To enforce applicable user agreements or policies, including our
            <small>Privacy OF USE</small> and to protect us, our users or the public from harm or illegal activities.</li>
          <li> If we notify you through our services (or in our privacy policy) that the information you provide will
            be shared in a particular manner and you provide such information.</li>
          <li> With third party vendors and other service providers who need access to your information to carry out
            work on our behalf (a shipping or payment processing vendor for example). In this specific case we
            shall always obtain your consent to share information with the specific third party vendor. </li>
        </ul>
        <p></p>

        <p>
          We may also share aggregated or anonymized information that does not directly identify you.
        </p>
        <p>
          We take reasonable measures to help protect personal information from loss, theft, misuse and unauthorized access, disclosure,
          alteration and destruction. All considering, you take all measures to protect your credentials against
          theft, disclosure, misuse and unauthorized access.
        </p>

        <p>
          You shall send you communication only about your account or our ongoing business relations.
        </p>
        <p>
          If you have any questions about this privacy policy, please contact us at: support@principal.software.
        </p>
      </Container>
    </section>
  </Layout>
);

const styles = {
  section: {
    pt: 10,
    pb: 3,
    position: 'relative',
    zIndex: 2,
  },
  containerBox: {
    display: 'flex',
    flexDirection: 'column',
    pb: [0, null, null, null, null, 7],
  },

};

export default PrivacyPage;
